import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import moment from "moment";

const StartSubscriptionModal = ({
  subscriptionShow,
  subscriptionData,
  toggleSubscriptionModal,
  UpdateSchoolSubscription,
  amountError,
  setAmountError,
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [school_detail_id, setSchool_detail_id] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [amount, setAmount] = useState("");
  const [duration, setDuration] = useState(null);
  const [changesMade, setChangesMade] = useState(false);

  const yearOption = [
    { value: 1, label: "1 Year" },
    { value: 2, label: "2 Years" },
    { value: 3, label: "3 Years" },
    { value: 4, label: "4 Years" },
    { value: 5, label: "5 Years" },
  ];
console.log(subscriptionShow ,"subscriptionDatasubscriptionData")
  // Reset modal values when opened
  useEffect(() => {
    if (subscriptionShow) {
      setModalOpen(true);
      setSchool_detail_id(subscriptionData.school_detail_id);

      if (subscriptionData.start_date) {
        const apiStart = new Date(subscriptionData.start_date);
        setStartDate(apiStart);

        if (subscriptionData.end_date) {
          const apiEnd = new Date(subscriptionData.end_date);
          setEndDate(apiEnd);

          // Auto select duration in years if both dates exist
          const diffYears =
            apiEnd.getFullYear() - apiStart.getFullYear();
          const matchPlan = yearOption.find(
            (opt) => opt.value === diffYears
          );
          if (matchPlan) setDuration(matchPlan.value);
        }
      }

      setAmount(subscriptionData.amount || "");
      setChangesMade(false); // reset change flag
    }
    else if (subscriptionShow == false){
       setModalOpen(false);
    }
  }, [subscriptionShow, subscriptionData]);

  // Handle start date change
  const dateHandler = (date) => {
    setStartDate(date);
    setEndDate(null); // reset end date
    setDuration(null); // reset plan
    setChangesMade(true);
  };

  // Handle plan change
  const handlePlanChange = (event) => {
    if (startDate && event) {
      const newEndDate = new Date(startDate);
      newEndDate.setFullYear(newEndDate.getFullYear() + event.value);

      setDuration(event.value);
      setEndDate(newEndDate);
      setChangesMade(true);
    }
  };

  // Handle amount change
  const amountHandler = (e) => {
    setAmount(e.target.value);
    setChangesMade(true);
  };

  // Submit data
  const dataSubmit = () => {
    if (!amount) {
      setAmountError(true);
      return;
    }
    const payload = {
      school_detail_id,
      start_date: moment(startDate).format("YYYY-MM-DD"),
      end_date: moment(endDate).format("YYYY-MM-DD"),
      type: "subscription",
      amount,
    };
    console.log(payload ,"payloadpayload")
    UpdateSchoolSubscription("",payload);
    setAmountError(false);
    setChangesMade(false);
    toggleSubscriptionModal();
  };

  // Cancel → restore API values
  const handleCancel = () => {
    setModalOpen(false);
    toggleSubscriptionModal();
  };

  return (
    <Modal
      backdrop={true}
      keyboard={false}
      className="confirm_delete_modal confirm_modal"
      show={modalOpen}
      aria-labelledby="md-modal"
      onHide={handleCancel}
    >
      <Modal.Header>
        <Modal.Title>Start Subscription</Modal.Title>
        <span className="pointer" onClick={handleCancel}>
          <i className="fas fa-times me-2 fs-6"></i>
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {/* Start Date */}
          <div className="col-12 mt-2">
            <label className="fw-bold mb-2">Start Date</label>
            <ReactDatePicker
              showIcon
              dateFormat="yyyy/MM/dd"
              wrapperClassName="trial_datePicker_superadmin"
              className="form-control"
              selected={startDate}
              onChange={dateHandler}
            />
          </div>

          {/* Subscription Plan */}
          <div className="col-12 mt-4">
            <label className="fw-bold mb-2">Select Subscription Plan</label>
            <Select
              type="select"
              value={
                duration
                  ? yearOption.find((o) => o.value === duration)
                  : null
              }
              options={yearOption}
              placeholder="Select Plan"
              onChange={handlePlanChange}
              isDisabled={!startDate} // disable until start date chosen
            />
          </div>

          {/* End Date */}
          <div className="col-12 mt-4">
            <label className="fw-bold mb-2">End Date *</label>
            <input
              className="form-control"
              value={endDate ? moment(endDate).format("YYYY/MM/DD") : ""}
              readOnly
            />
          </div>

          {/* Amount */}
          <div className="col-12 mt-4">
            <label className="fw-bold mb-2">Amount *</label>
            <input
              className="form-control amount_subscription"
              type="number"
              value={amount}
              onChange={amountHandler}
            />
            {amountError && (
              <div className="error field-error">This field is required!</div>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-secondary apply-btn min-75px me-4"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          className="btn btn-sm btn-primary apply-btn min-75px"
          onClick={dataSubmit}
          disabled={!changesMade} // disable until user changes something
        >
          Ok
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default StartSubscriptionModal;
